import React, { memo, useState, ChangeEvent } from 'react';
import styled from 'styled-components';
import ModalContainer, { ButtonGroup } from '@/shared/components/modal/ModalContainer';
import StyledPassword from '@/shared/components/atoms/StyledPassword';
import StyledButton from '@/shared/components/atoms/StyledButton';
import theme from '@/styles/theme';
import { useReceptionMode } from '../hooks/useReceptionMode';

type ScanExitModalProps = {
	onClose: () => void;
	onConfirm: () => void;
};

// 스캔 모드 나가기 모달 (리셉션 모드 자체를 종료)
const ScanExitModal = memo<ScanExitModalProps>(({ onClose, onConfirm }) => {
	const { exit } = useReceptionMode();
	const [password, setPassword] = useState('');

	const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value);

	const handleConfirm = async () => {
		try {
			await exit(password);
			onConfirm();
		} catch {
			// 실패 메시지는 axios 인터셉터에서 toast로 표시됨
		}
	};

	return (
		<ModalContainer maxWidth={480} title="스캔 모드 나가기" onClose={onClose}>
			<Description>
				스캔 모드에서 나가게되면 이전에 로그인하셨던 관리자 계정으로 돌아가게 되며, 접근 권한에 따라 민감한 데이터에
				접근할 수 있습니다. 스캔 모드에서 나가시겠어요?
			</Description>
			<Field>
				<FieldLabel>로그인 비밀번호 입력</FieldLabel>
				<StyledPassword value={password} onChange={handlePasswordChange} placeholder="비밀번호 입력" />
			</Field>
			<ButtonGroup>
				<StyledButton width={130} onClick={onClose}>
					취소
				</StyledButton>
				<StyledButton
					width={200}
					fontColor={theme.colors.whiteColor}
					bgColor={theme.colors.activeRedOrange}
					border="none"
					disabled={!password}
					onClick={handleConfirm}>
					스캔모드 나가기
				</StyledButton>
			</ButtonGroup>
		</ModalContainer>
	);
});

ScanExitModal.displayName = 'ScanExitModal';

export default ScanExitModal;

const Description = styled.div`
	font-size: 14px;
	line-height: 22px;
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
	margin-bottom: 24px;
`;
const Field = styled.div`
	margin-top: 4px;
`;
const FieldLabel = styled.div`
	font-size: 14px;
	margin-bottom: 8px;
`;
